import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useMedia } from "use-media";
import * as S from "./styles";

function CustomTooltip({ title, description, label }) {
  const ref = useRef();
  const [showTooltip, setShowToolip] = useState(false);
  const isMobile = useMedia({ maxWidth: 767 });

  const theme = createTheme({
    overrides: {
      MuiTooltip: {
        tooltip: {
          padding: isMobile ? "15px !important" : "15px",
          backgroundColor: "#fff",
          maxWidth: isMobile ? "350px" : "545px",
          borderRadius: "3.671px",
          background: "var(--Color-Surface-default, #fafafa)",
          boxShadow:
            "0px 0px 0.459px 0.459px rgba(0, 0, 0, 0.12), 0px 1.835px 5.506px 1.835px rgba(0, 0, 0, 0.25)",
        },
      },
    },
  });

  function handleTooltip() {
    setShowToolip(!showTooltip);
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowToolip(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [showTooltip]);

  return (
    <MuiThemeProvider theme={theme}>
      <Tooltip
        title={
          <div>
            <S.TooltipTitle>
              <span>{title}</span>
              <button onClick={() => setShowToolip(false)}>x</button>
            </S.TooltipTitle>
            <br />
            <S.TooltipDescription>{description}</S.TooltipDescription>
          </div>
        }
        placement={"top"}
        interactive={true}
        open={showTooltip}
        ref={ref}
      >
        <div onClick={handleTooltip}>{label}</div>
      </Tooltip>
    </MuiThemeProvider>
  );
}

export default CustomTooltip;
